import { GET_EVENTS_SUCCESS, GET_EVENTS_FAILURE, CLEAR_EVENTS, GET_EVENT_SUCCESS } from '../types';
import SportsService from '../../services/sportsService';
import { IEvent, ITeamMember } from '@incentivegames/ig-types/lib/interfaces/apiContracts';
import { setLoadingDataForGame, setLoadingDataForHeader } from './dreamteamActions';

const sportsService = new SportsService();

export const clearEvents = () => ({
  type: CLEAR_EVENTS
});

export const getEventSuccess = (event: IEvent) => ({
  type: GET_EVENT_SUCCESS,
  event
});

export const getEventFailure = (error: any) => ({
  type: GET_EVENTS_FAILURE,
  error
});

export const getEventsSuccess = (events: IEvent[]) => ({
  type: GET_EVENTS_SUCCESS,
  events
});

export const getEventsFailure = (error: any) => ({
  type: GET_EVENTS_FAILURE,
  error
});

export const getEventsByGroupId = (eventGroupId: number) => {
  return (dispatch: any) => {
    sportsService
      .getEventsByGroupId(eventGroupId)
      .then((response: any) => {
        dispatch(getEventsSuccess(response.data?.events));
      })
      .catch((error: any) => {
        dispatch(getEventsFailure(error));
      });
  };
};

export const getEventsByIds = (eventIds: number[]) => {
  return (dispatch: any) => {
    dispatch(setLoadingDataForHeader(true));
    sportsService
      .getEventsByIds(eventIds)
      .then((response: any) => {
        dispatch(setLoadingDataForHeader(false));

        dispatch(getEventsSuccess(response.data?.events));
        dispatch(setLoadingDataForGame(false));
      })
      .catch((error: any) => {
        dispatch(getEventsFailure(error.response.data.errorCode ?? error));
        dispatch(setLoadingDataForGame(false));
        dispatch(setLoadingDataForHeader(false));
      });
  };
};

export const getEventsByTeam = (teamMembers: ITeamMember[]) => {
  return (dispatch: any) => {
    if (teamMembers) {
      let eventIds: number[] = [];
      teamMembers.forEach((teamMember: ITeamMember) => {
        if (!eventIds.includes(teamMember.eventId)) {
          if (teamMember.eventId) eventIds.push(teamMember.eventId);
        }
      });
      if (eventIds.length) {
        dispatch(getEventsByIds(eventIds));
      } else {
        dispatch(setLoadingDataForGame(false));
      }
    } else {
      dispatch(setLoadingDataForGame(false));
    }
  };
};
